/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { handleActions } from 'redux-actions';

const initialState = {
  loading: false,
  loadingSamples: false,
  loadingDefaults: false,
  defaults: {},
  items: [],
  samples: [],
  mutating: {}
};

const stopMutating = ({ workspace_id }, mutating) => {
  const result = Object.assign({}, mutating);
  delete result[workspace_id];
  return result;
};

export const getWorkspacesStart = state => ({
  ...state,
  loading: true
});
export const getWorkspacesSuccess = (state, action) => ({
  ...state,
  loading: false,
  items:
    action &&
    action.payload &&
    action.payload.response &&
    action.payload.response.entities &&
    action.payload.response.entities.workspaces
      ? [...Object.keys(action.payload.response.entities.workspaces)]
      : []
});
export const getWorkspacesError = state => ({
  ...state,
  loading: false,
  items: []
});

export const getWorkspaceStart = state => ({ ...state });
export const getWorkspaceSuccess = state => ({ ...state });
export const getWorkspaceError = state => ({ ...state });

export const getStarterWorkspaceStart = state => ({ ...state });
export const getStarterWorkspaceSuccess = state => ({ ...state });
export const getStarterWorkspaceError = state => ({ ...state });

export const getSampleWorkspacesStart = state => ({
  ...state,
  loadingSamples: true
});
export const getSampleWorkspacesSuccess = state => ({
  ...state,
  loadingSamples: false
});
export const getSampleWorkspacesError = state => ({
  ...state,
  loadingSamples: false
});

export const updateWorkspaceStart = (state, action) => ({
  ...state,
  mutating: { ...state.mutating, [action.payload.workspace.workspace_id]: true }
});
export const updateWorkspaceSuccess = (state, action) => ({
  ...state,
  mutating: stopMutating(action.payload.workspace, state.mutating)
});
export const updateWorkspaceError = (state, action) => ({
  ...state,
  mutating: stopMutating(action.payload.workspace, state.mutating)
});

export const reducer = handleActions(
  {
    conversation: {
      workspaces: {
        getWorkspacesStart,
        getWorkspacesSuccess,
        getWorkspacesError,
        getWorkspaceStart,
        getWorkspaceSuccess,
        getWorkspaceError,

        getSampleWorkspacesStart,
        getSampleWorkspacesSuccess,
        getSampleWorkspacesError,

        getStarterWorkspaceStart,
        getStarterWorkspaceSuccess,
        getStarterWorkspaceError,

        updateWorkspaceStart,
        updateWorkspaceSuccess,
        updateWorkspaceError
      }
    }
  },
  initialState
);

export default reducer;
